<button class="go-to-top" (click)="scrollToTop()" [class.visible]="isVisible">
  <i class="fas fa-arrow-up"></i>
</button>
